import Entity from '../entity'

export default class StockMvtReason extends Entity<number>{
    sign: number;
    name: string;
}


